import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import './header.css';

import VWGoALogo from '../../media/icons/VWGoA_Logo.png';

import VWFSLogoEN from '../../media/icons/VWFS_Logo_EN.png';
import AUFSLogoEN from '../../media/icons/AUFS_Logo_EN.png';
import VWFSLogoFR from '../../media/icons/VWFS_Logo_FR.png';
import AUFSLogoFR from '../../media/icons/AUFS_Logo_FR.png';

const header = function ({
    country,
    language,
}) {
    if(country.toLowerCase() === "canada") {
        const aufsLogo = language === "ENG"? AUFSLogoEN : AUFSLogoFR;
        const vwfsLogo = language === "ENG"? VWFSLogoEN : VWFSLogoFR;

        return <div className="o-layout VWGoA-Logo u-pv-large" data-test-id={`header-vwfs-aufs-logos-${language}`}>
            <div className="o-layout__item u-1/2 u-1/1@m u-text-left u-text-center@m">
            <img className='logo-aufs-canada' src={aufsLogo} alt='graphic logo of Audi Financial Services' />
            </div>
            <div className="o-layout__item u-1/2 u-1/1@m u-text-right u-text-center@m">
            <img className='logo-vwfs-canada' src={vwfsLogo} alt='graphic logo of Volkswagen Financial Services' />
            </div>
        </div>;
    }

    return <div className="VWGoA-Logo" data-test-id="header-vwgoa-logo">
        <img className='logo u-block u-block-center' src={VWGoALogo} alt='graphic logo of VWGOA' />
    </div>;
}

const mapStateToProps = state => ({
    country: state.initialReducer.country,
    language: state.initialReducer.language,
});

export default connect(mapStateToProps)(withTranslation()(header));

